import { BoxProps, Text } from "@chakra-ui/react";
import { Element } from "@prismicio/react";
import paragraph from "src/lib/renderer/elements/paragraph";
import { span } from "src/lib/renderer/elements/typography";
import { Serializer } from "src/lib/renderer/types";
import { getComponentFromSelector } from "src/lib/renderer/utils";

export const CELL_OVERRIDES: Partial<Record<Element, Serializer<BoxProps>>> = {
  paragraph: (args) =>
    paragraph({
      ...args,
      overrideProps: {
        marginBottom: "0",
        fontSize: undefined,
        color: undefined,
      },
    }),

  span: (args) =>
    span({
      ...args,
      overrideProps: {
        fontSize: "font-16",
        color: undefined,
      },
    }),

  label: (args) =>
    getComponentFromSelector(
      [
        {
          condition: ({ element }) => element.data?.label === "subtitle",
          component: ({ key, content, overrideProps }) => (
            <Text
              as="span"
              key={key}
              {...overrideProps}
              color="text-light"
              fontSize="font-14"
            >
              {content}
            </Text>
          ),
        },
      ],
      args
    ),
};

/**
 * Despite the apparent ugliness of this function,
 * it will never actually go through more than 2 iterations,
 * because cells do not contain more than one subtitle paragraph.
 */
export const hasOnlySubtitle = (
  item?: Gatsby.PrismicStructuredTextType["raw"]
) =>
  item?.every?.(
    (el: any) =>
      el?.text === "" ||
      el?.spans?.some((span: any) => span?.data?.label === "subtitle")
  );
